<template>
    <AjanlatBase
        :titleExtra="titleExtra"
        v-if="masikRendszamVisible()
        || allianzPartnerVisible()
        || allianzKarVisible()"
    >

        <v-form slot="biztositoi-adatok" ref="ajanlat-adatok">

            <v-layout row wrap>

                <BnFormField v-if="masikRendszamVisible()" :attributes="masik_rendszam"/>

                <BnFormField v-if="allianzPartnerVisible()" :attributes="allianz_partner_szerzszam"/>

                <template v-if="allianzKarVisible()">

                    <BnFormField :key="index" v-for="(ev, index) in getKarEv()"
                                 :attributes="{
                            label: 'Károk azonos jármű-kategóriában ' + ev + ' -ben/ban',
                            type: 'select',
                            visible: true,
                            editable: true,
                            help: false,
                            options: [
                                {key: 0, value: 'Nem okoztam kárt' },
                                {key: 1, value: '1 kárt okoztam' },
                                {key: 2, value: '2 kárt okoztam' },
                                {key: 3, value: '3 kárt okoztam' },
                                {key: 4, value: '4 vagy több kárt okoztam'},
                            ],
                            itemsText: 'value',
                            itemsValue: 'key',
                            mezo: 'tf_' + ev + '_kardb',
                            path: 'tarifaData.evenkenti_karok.tf_' + ev + '_kardb'
                        }"
                    >
                    </BnFormField>

                </template>

            </v-layout>

        </v-form>

    </AjanlatBase>

</template>

<script>
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import AjanlatBase from '../KGFBAjanlatBase.vue';
import offerData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/OfferData';

export default {
    components: { BnFormField, AjanlatBase },
    mixins: [offerData],
    methods: {
        masikRendszamVisible() {
            return this.kedvezmenyek.pluszauto === true;
        },
        allianzPartnerVisible() {
            return this.kedvezmenyek.egyuttlakas === true
                || (this.kedvezmenyek.egyuttcasco === true && !this.egyuttkotve)
                || this.kedvezmenyek.egyuttelet === true
                || this.kedvezmenyek.myhome === true;
        },
        allianzKarVisible() {
            return parseInt(this.$store.getters.tarifaData.ajanl_kock_kezd, 10) < 20220101;
        },
        muszakiVizsgaVisible() {
            return this.$store.getters.kedvezmenyekalaptabla['1'].muszaki_vizsga_180_napon_belul === true;
        },
        getKarEv() {
            const arr = [];
            for (let i = 2020; i >= 2017; i -= 1) {
                arr.push(i);
            }
            return arr;
        },
    },
    data() {
        return {
            name: 'AjanlatAdatokB1_V0',
            version: 'v0',
            masik_rendszam: {
                type: 'text',
                label: 'Másik biztosított gépjármű rendszáma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'masik_rendszam',
                path: 'tarifaData.masik_rendszam',
            },
            allianz_partner_szerzszam: {
                type: 'text',
                label: 'Az együttkötési kedvezmény alapjául szolgáló biztosítás kötvényszáma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'allianz_partner_szerzszam',
                path: 'tarifaData.allianz_partner_szerzszam',
                mask: '!V',
            },
        };
    },
};
</script>
